import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GlobalProvider } from './context';
import { HashRouter } from 'react-router-dom';
import './index.css';


ReactDOM.render(
  <GlobalProvider>
     {/* <HashRouter>
    <App />
  </HashRouter> */}
   <App />
  </GlobalProvider>,
  document.getElementById('root')
);